module.exports = __webpack_public_path__ + "static/img/WANG_CHAO-PAO.jpg";